import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './guards/auth/auth.guard';
import {PrivilegeGuard} from './guards/privilege/privilege.guard';
import {LoginComponent} from './modules/login/login.component';
import {ResetPasswordComponent} from './modules/login/reset-password/reset-password.component';
import {ChangePasswordComponent} from './modules/login/change-password/change-password.component';
import {LayoutComponent} from './layout/layout.component';
import {BlankComponent} from './components/blank/blank.component';
import {AccessDeniedComponent} from './components/access-denied/access-denied.component';
import {RoleSwitchingComponent} from './modules/login/role-switching/role-switching.component';
import {ConfirmEmailComponent} from './modules/login/confirm-email/confirm-email.component';
import {MyProfileComponent} from './components/my-profile/my-profile.component';
import {environment} from '../environments/environment';
import {PendingChangesGuard} from './guards/pendingChanges/pending-changes.guard';
import {SandboxComponent} from './modules/back-office/sandbox/sandbox.component';
import {OauthComponent} from "./modules/login/oauth/oauth.component";

const routes: Routes = [
  {
    path: '',
    redirectTo: 'app/sales-terminal',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    canActivate: [AuthGuard],
    path: 'login/oauth',
    component: OauthComponent
  },
  {
    canActivate: [AuthGuard, PrivilegeGuard],
    path: 'role-switching',
    component: RoleSwitchingComponent
  },
  {
    path: 'registration',
    loadChildren: () => import('./modules/registration/registration.module').then(m => m.RegistrationModule),
    data: {
      breadcrumb: 'general.api_menu_registration'
    }
  },
  {
    path: 'forgot-password',
    component: ResetPasswordComponent
  },
  {
    path: 'reset-password/:secret',
    component: ResetPasswordComponent
  },
  {
    path: 'reset-email/:uuid',
    component: ConfirmEmailComponent,
    data: {
      breadcrumb: 'general.api_menu_email_confirmation'
    }
  },
  {
    path: 'change-password',
    canActivate: [AuthGuard],
    component: ChangePasswordComponent
  },
  {
    path: 'app',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'access-denied',
        component: AccessDeniedComponent
      },
      {
        path: 'sales-terminal',
        loadChildren: () => import('./modules/sales-terminal/sales-terminal.module').then(m => m.SalesTerminalModule),
        canActivate: [PrivilegeGuard],
        data: {
          breadcrumb: 'general.api_menu_salespoint_sales'
        }
      },
      {
        path: 'back-office',
        loadChildren: () => import('./modules/back-office/back-office.module').then(m => m.BackOfficeModule),
        canActivate: [PrivilegeGuard],
        data: {
          breadcrumb: 'general.api_menu_back-office'
        }
      },
      {
        path: 'admin',
        loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule),
        canActivate: [PrivilegeGuard],
        data: {
          breadcrumb: 'general.api_menu_admin'
        }
      },
      {
        path: 'reports',
        loadChildren: () => import('./modules/reports/reports.module').then(m => m.ReportsModule),
        canActivate: [PrivilegeGuard],
        data: {
          breadcrumb: 'general.api_menu_reports'
        }
      },
      {
        path: 'help',
        loadChildren: () => import('./modules/help/help.module').then(m => m.HelpModule),
        canActivate: [PrivilegeGuard],
        data: {
          breadcrumb: 'general.api_menu_help'
        }
      },
      {
        path: 'profile',
        component: MyProfileComponent,
        canDeactivate: [PendingChangesGuard],
        data: {
          breadcrumb: 'general.api_menu_my_profile'
        },
        children: []
      }
    ]
  },
  {
    path: 'window',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'blank',
        component: BlankComponent,
        children: []
      },
      {
        path: 'sales-terminal',
        loadChildren: () => import('./modules/sales-terminal/sales-terminal.module').then(m => m.SalesTerminalModule),
        canActivate: [PrivilegeGuard]
      }
    ]
  },
  {
    path: 'sandbox',
    component: SandboxComponent
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'app/sales-terminal'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    enableTracing: environment.enableTracing,
    paramsInheritanceStrategy: 'always',
    preloadingStrategy: PreloadAllModules,
    canceledNavigationResolution: 'computed'
  })],
  exports: [RouterModule]
})

export class AppRoutingModule {}
